import {post} from '@/api'
import {ValidateEmailOtpResponse, CreatePasswordRequest} from '../models'

export const createPassword = (data: CreatePasswordRequest) =>
    post('/oppapi/client/v1/signup', data)

export const validateRefCode = (ref: string) =>
    post('/oppapi/client/v1/signup/code', {
        ref
    })

export const validateEmail = (email: string) =>
    post('/oppapi/client/v1/signup/email', {
        email
    })

export const validateEmailOtp = (email: string, code: string) =>
    post<ValidateEmailOtpResponse>('/oppapi/client/v1/signup/validation', {
        email,
        code
    })
